"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("../common");
var helpers_1 = require("./helpers");
var popUp_1 = require("./popUp/popUp");
require("./widget.css");
require("./popUp/popUp.css");
var Widget = /** @class */ (function () {
    function Widget() {
        this.container = document.createElement('div');
        this.button = document.createElement('button');
        this.iframeWrapper = document.createElement('div');
        this.iframe = document.createElement('iframe');
        this.notificator = document.createElement('div');
        this.html = document.querySelector('html');
        this.notificatorCounter = 0;
        this.visualParams = null;
        this.serverParams = null;
        this.CLASS_NAME = 'temporary-widget-class';
        this.setIsOpenButton = (0, helpers_1.setButtonIcon)(this.button);
    }
    Widget.prototype.initChat = function (paramData, user) {
        return __awaiter(this, void 0, void 0, function () {
            var paramsServer, widgetSettings;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!paramData.server || !paramData.clientId || !paramData.host)
                            return [2 /*return*/];
                        paramsServer = paramData.server.replace(/^(http|https):\/\//, '');
                        return [4 /*yield*/, (0, helpers_1.getWidgetSettings)(paramsServer, paramData.clientId)];
                    case 1:
                        widgetSettings = _a.sent();
                        if (!widgetSettings)
                            return [2 /*return*/];
                        if (!this.visualParams)
                            this.setParams(widgetSettings);
                        this.createButtonAndIframeOnPage(paramData, paramsServer);
                        this.serverParams = {
                            server: paramsServer,
                            host: paramData.host,
                            init: true,
                            user: user,
                            initParamData: __assign({}, paramData),
                        };
                        this.setIsOpenButton = (0, helpers_1.setButtonIcon)(this.button, widgetSettings.open_button_color || undefined);
                        this.setIsOpenButton(false);
                        sessionStorage.setItem('serverParams', JSON.stringify(this.serverParams));
                        this.addEventListeners();
                        if (this.visualParams)
                            this.initialWidget(widgetSettings.open_button_color, user);
                        if (widgetSettings.open_button_horizontal_alignment)
                            this.iframeWrapper.classList.add("".concat(widgetSettings.open_button_horizontal_alignment, "-open"));
                        (0, popUp_1.setPopUp)({
                            isActive: widgetSettings.popup_is_active,
                            title: widgetSettings.popup_title,
                            text: widgetSettings.popup_text,
                            interval: widgetSettings.popup_interval,
                            position: widgetSettings.open_button_horizontal_alignment || 'right',
                        }, {
                            appendCallback: function (popUpContent) { return _this.container.insertAdjacentHTML('beforeend', popUpContent); },
                            openWidget: function () { return _this.openWidget(); },
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Widget.prototype.setUserAccount = function (email, name) {
        var iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ userData: { email: email, name: name, type: 'userData' } }, '*');
    };
    Widget.prototype.createButtonAndIframeOnPage = function (paramData, paramsServer) {
        var meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = 'user-scalable=no, initial-scale=1.0, maximum-scale=1.0, width=device-width';
        document.head.appendChild(meta);
        this.container.classList.add("".concat(this.CLASS_NAME, "__container"));
        this.button.classList.add('class', "".concat(this.CLASS_NAME, "__button"));
        this.button.setAttribute('aria-label', 'Open Widget');
        this.iframeWrapper.classList.add("".concat(this.CLASS_NAME, "__iframe-wrapper"));
        this.iframeWrapper.classList.add('iframe-wrapper-hidden');
        this.iframe.setAttribute('scrolling', 'no');
        this.iframe.setAttribute('id', 'widgetIframe');
        this.iframe.setAttribute('name', 'widgetIframe');
        this.iframe.setAttribute('title', 'Iframe with widget');
        var protocol = paramsServer.includes('localhost:') ? 'http://' : 'https://';
        var prefix = paramData.server ? "".concat(protocol).concat(paramsServer) : '';
        this.iframe.setAttribute('src', "".concat(prefix, "/index.html?id=").concat(paramData.clientId, "&clientUrl=").concat(parent.location.href));
        this.iframeWrapper.appendChild(this.iframe);
        /** Временно решили скрыть счетчик входящих сообщений. Видимо потом должны вернуть */
        // this.container.appendChild(this.notificator);
        this.container.appendChild(this.iframeWrapper);
        this.html.appendChild(this.container);
        this.listenChatMessages();
    };
    Widget.prototype.setParams = function (params) {
        this.visualParams = { setParams: true, params: params };
        if (this.serverParams)
            this.initialWidget(params.open_button_color);
        this.setIsOpenButton = (0, helpers_1.setButtonIcon)(this.button, params.open_button_color || undefined);
        (0, helpers_1.setAlignment)(this.container, params.open_button_horizontal_alignment);
    };
    Widget.prototype.disableNameAndEmailInput = function (isDisabledNameAndEmail) {
        var iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ isDisabledNameAndEmail: isDisabledNameAndEmail }, '*');
    };
    Widget.prototype.setCustomFields = function (customFields) {
        var iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ customFields: customFields }, '*');
    };
    Widget.prototype.addEventListeners = function () {
        var _this = this;
        this.button.addEventListener('click', function () {
            (0, popUp_1.closePopUp)();
            if (!(0, helpers_1.hasClass)(_this.container, 'is-iframe-shown'))
                return _this.openWidget();
            _this.closeWidget();
        }, false);
        window.addEventListener('keyup', function (event) {
            if (event.keyCode === 27) {
                _this.closeWidget();
            }
        });
        window.addEventListener('message', function (msg) {
            if (msg.data.link && msg.data.link.href) {
                window.open(msg.data.link.href, '_blank');
            }
            if (msg.data && msg.data.type === 'close widget') {
                _this.closeWidget();
            }
        });
    };
    Widget.prototype.listenChatMessages = function () {
        var _this = this;
        /* listen messages from iframe JS */
        window.addEventListener('message', function (msg) {
            if (msg.data && msg.data.type === 'new message')
                _this.handleNewMessage();
        }, false);
    };
    Widget.prototype.handleNewMessage = function () {
        if (!(0, helpers_1.hasClass)(this.container, 'is-iframe-shown')) {
            var counter = ++this.notificatorCounter;
            if (!(0, helpers_1.hasClass)(this.notificator, 'visible'))
                this.notificator.classList.add('visible');
            this.notificator.textContent = counter.toString();
        }
    };
    Widget.prototype.closeWidget = function () {
        var _a;
        var iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ isOpen: false }, '*');
        (_a = this.setIsOpenButton) === null || _a === void 0 ? void 0 : _a.call(this, false);
        this.container.classList.remove('is-iframe-shown');
        this.iframeWrapper.classList.add('iframe-wrapper-hidden');
        this.iframeWrapper.classList.remove('iframe-wrapper-shown');
    };
    Widget.prototype.openWidget = function () {
        this.container.classList.add('is-iframe-shown');
        this.iframeWrapper.classList.add('iframe-wrapper-shown');
        this.iframeWrapper.classList.remove('iframe-wrapper-hidden');
        this.notificatorCounter = 0;
        this.notificator.textContent = '';
        this.notificator.classList.remove('visible');
        this.sayIframeIsOpen();
    };
    Widget.prototype.sayIframeIsOpen = function () {
        var _a;
        var iframeDoc = this.iframe.contentWindow;
        (_a = this.setIsOpenButton) === null || _a === void 0 ? void 0 : _a.call(this, true);
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ isOpen: true }, '*');
    };
    Widget.prototype.initialWidget = function (color, user) {
        var _this = this;
        this.iframe.onload = function () {
            var _a, _b;
            var iframeDoc = _this.iframe.contentWindow;
            _this.notificator.setAttribute('class', 'temporary-widget-class__notificator');
            _this.notificator.style.setProperty('--notificator-color', color || common_1.DEFAULT_BACKGROUND_COLOR);
            if (!iframeDoc || !_this.visualParams)
                return;
            _this.visualParams.params.blocks = ((_b = (_a = _this.visualParams.params) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.length)
                ? _this.visualParams.params.blocks
                : ['chat'];
            /* setTimeout нужен чтобы в React успевал отрендериться компонент App и подписаться на событие 'message' */
            setTimeout(function () {
                // Передаем данные приложению App
                iframeDoc.postMessage({ serverParams: _this.serverParams, visualParams: _this.visualParams, user: user }, '*');
            }, 200);
            _this.container.appendChild(_this.button);
        };
    };
    return Widget;
}());
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
window.Happydesk = new Widget();
// @ts-ignore
window.Pulsedesk = new Widget();
/* eslint-enable */
